import { Link } from 'react-router-dom';
import { useTranslation } from '../i18n';
import { Button } from '../components/ui/button';

export default function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <div className="mx-auto flex max-w-lg flex-col items-center px-4 py-24 text-center">
      <p className="text-6xl font-bold tracking-tight text-brand">404</p>
      <h1 className="mt-4 text-2xl font-semibold text-fg">{t('notFound.title')}</h1>
      <p className="mt-2 text-muted">{t('notFound.body')}</p>
      <div className="mt-8">
        <Link to="/">
          <Button>{t('common.backToHome')}</Button>
        </Link>
      </div>
    </div>
  );
}
